import React from "react";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import GroupsIcon from "@mui/icons-material/Groups";
import styles from "../styles/styles";

export default function TrainHVACPanel({
    cars = [],
    status = {},
    atcSpeed = 0
}) {
    return (
        <div style={styles.trainHVACContainer}>

            {/* SIDEBAR */}
            <div style={styles.trainHVACSidebar}>

                {/* LABELS */}
                <div style={styles.trainHVACSidebarLabels}>

                    <div
                        style={{
                            ...styles.trainHVACStatusLabel,
                            background:
                                status.cabineAtiva
                                    ? "#967ADD"
                                    : styles.trainHVACStatusLabel.background,

                            color:
                                status.cabineAtiva
                                    ? "#ffffff"
                                    : "#111827"
                        }}
                    >
                        Cabine ativa
                    </div>

                    <div
                        style={{
                            ...styles.trainHVACStatusLabel,
                            background:
                                status.atcAtivo
                                    ? "#ef4444"
                                    : styles.trainHVACStatusLabel.background,

                            color:
                                status.atcAtivo
                                    ? "#ffffff"
                                    : "#111827"
                        }}
                    >
                        ATC ativo
                    </div>

                    <div
                        style={{
                            ...styles.trainHVACStatusLabel,
                            background:
                                status.atcIsolado
                                    ? "#967ADD"
                                    : styles.trainHVACStatusLabel.background,

                            color:
                                status.atcIsolado
                                    ? "#ffffff"
                                    : "#111827"
                        }}
                    >
                        ATC isolado
                    </div>

                    <div
                        style={{
                            ...styles.trainHVACStatusLabel,
                            background:
                                status.atcFalha
                                    ? "#ef4444"
                                    : styles.trainHVACStatusLabel.background,

                            color:
                                status.atcFalha
                                    ? "#ffffff"
                                    : "#111827"
                        }}
                    >
                        ATC em falha
                    </div>

                </div>

                {/* VALORES */}
                <div style={styles.trainHVACSidebarValues}>

                    <div
                        style={{
                            ...styles.trainHVACATCBox
                        }}
                    >
                        {status.velocidadeAtc ?? "-"}
                    </div>

                    <div
                        style={{
                            ...styles.trainHVACStatusValue,
                            background:
                                status.vr
                                    ? "#ef4444"
                                    : styles.trainHVACStatusValue.background,

                            color:
                                status.vr
                                    ? "#ffffff"
                                    : "#111827"
                        }}
                    >
                        VR
                    </div>

                </div>

            </div>

            {/* CARROS */}
            <div style={styles.trainHVACGrid}>
                {cars.map(car => (
                    <div
                        key={car.id}
                        style={styles.trainHVACCardWrapper}
                    >

                        <div style={styles.trainHVACCard}>

                            <div style={styles.trainHVACTopRow}>
                                <AcUnitIcon style={{ fontSize: 16 }} />
                                <span>{car.temp}</span>
                            </div>

                            <div style={styles.trainHVACBottomRow}>
                                <GroupsIcon style={{ fontSize: 16 }} />

                                <div style={styles.trainHVACPassengerValue}>
                                    {car.passageiros}
                                </div>
                            </div>

                        </div>

                        <div style={styles.trainHVACLabel}>
                            Carro {car.id}
                        </div>

                    </div>
                ))}
            </div>

        </div>
    );
}
